import React, { useState, useEffect } from 'react'
import CommonsService from '@/services/commons.service'
import SignUpService from '@/app-domains/user/onboarding/signup.service'
import { InputMask } from '@/components/InputMask/InputMask'
import { Button } from '@/components/Button/Button'

import './SignUpSecondStep.sass'
import AuthService from '@/app-domains/user/auth/Auth.service'
import { Link } from 'react-router-dom'
import ToastService from '@/components/Toast/Toast.service'

export function SignUpSecondStep () {
  const [code, setCode] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const handleCodeChange = (code) => {
    setCode(code)
  }
  
  const resendCode = () => {
    const username = CommonsService.getQueryParams('username')
    SignUpService.resendCode(username)
  }

  useEffect(() => {
    if (!CommonsService.getQueryParams('username')) CommonsService.goToPage('/auth/signup')
  }, [])

  const onSubmitHandler = (e) => {
    if (submitting) return e?.preventDefault()
    if (!code) {
      ToastService.show({
        type: 'error',
        title: 'Error',
        message: 'Code is empty'
      })
      setSubmitting(false)
      return
    }

    setSubmitting(true)
    ToastService.show({
      type: 'info',
      title: 'Verifying',
      message: 'Sending verification code',
    })
    const username = CommonsService.getQueryParams('username')
    SignUpService.sendConfirmationCode(username, code).catch(() => {
      ToastService.show({
        type: 'error',
        title: 'Error',
        message: 'Invalid verification code',
      })
      setSubmitting(false)
    })
    e?.preventDefault()
  }
  return (<div className='verification-code-container'>
    <Link className='logout-link' onClick={AuthService.signOut}>Log out</Link>
    <div className="verification-code-form">
      <p className="verification-code-form-main-text">
        <span>We've just sent you an email with the verification code</span>
      </p>
      <InputMask label="Verification code" onInput={handleCodeChange} />
      <div className="login-button verify__button">
        <Button content="Verify account" click={onSubmitHandler} size="large"/>
      </div>
      <div className="verification-code-form-resend">
        There's no code in your inbox? <a onClick={resendCode}>Resend code</a>
      </div>
    </div>
  </div>)
}
